import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private refreshTokenTimeOut;

  constructor(private http : HttpClient, private encryptService:EncryptionService) { }

  /**
   * Renvoie les headers pour les requêtes http
   */
  loadToken()  : HttpHeaders {
    const token = JSON.parse(this.encryptService.decrypt(localStorage.getItem('user'))).token;
    const id_pers = JSON.parse(this.encryptService.decrypt(localStorage.getItem('user'))).id_pers;
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'head_hex': '' + token,
      'hid_hex': '' + id_pers,
      'x-api-key': '$2y$15$uNFF2KoRNm4KTR7d8tkc2O1S/Ejxy6w9AvAGYV96zH/uk.GGfTPWa',
      'timeout' : '600000'
    });
    
    return httpHeaders;
  }

  refreshToken() {
    console.log("token refresh en cours");
    let headers = this.loadToken();
    let request = "/api/refresh-token";
    return this.http.get(request, {headers : headers}).pipe(
      map( value => {
        if(value["status"] !== "success") {

        }else {
          let token = value["token"];
          let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
          user['token'] = value["token"]; //=> on met le nouveau token
          localStorage.setItem("user", this.encryptService.encrypt(JSON.stringify(user))); 

          this.startRefreshToken();
        }
      })
    );
  }

  /**
   * Timer pour rafraîchir le token
   */
  startRefreshToken() {
    let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let token = JSON.parse(atob(user.token.split('.')[1]));//=> on reprend le token
    
    const expire = new Date(token.exp * 1000);
    const timeout = expire.getTime() - Date.now() - (120 * 1000);//=> si il reste moins de deux minutes on rafraichis le token

    this.refreshTokenTimeOut = setTimeout(() =>  {
      this.refreshToken().subscribe();
    }, timeout);
  }

  stopRefreshToken() {
    clearTimeout(this.refreshTokenTimeOut);
  }


  

}
